var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamics-fiat-modal"},[(_vm.asset)?_c('div',{staticClass:"fiat-modal-body"},[_c('div',{style:({
        textAlign:'center',
        width: '348px',
        alignSelf: 'center',
    })},[_c('div',{style:({
          fontSize: '20px',
          fontWeight:'bold',
          lineHeight: '24px',
          color: '#333333',
          marginBottom: '18px'
      })},[_vm._v("\n        "+_vm._s(_vm.asset.fullName)+"("+_vm._s(_vm.asset.name)+")\n        "),_c('br'),_vm._v("Fiat Deposit Instructions\n      ")]),_vm._v(" "),_c('div',{style:({
          fontSize: '12px',
          fontWeight:'bold',
          lineHeight: '14px',
          color: 'red',
          marginBottom: '18px'
      })},[_vm._v("! CRITICAL INFORMATION !")]),_vm._v(" "),_c('div',{style:({
          fontSize: '12px',
          lineHeight: '14px',
          color: 'red',
          marginBottom: '18px'
      })},[_vm._v("You must include your user ID information in the reference section of the wire transfer. Crypto Swap Limited will not be held responsible for funds that arrive in our account that do not bear the USERS ACCOUNT ID")])]),_vm._v(" "),_vm._l(([
          { 
              title: 'WIRE TRANSFER COORDINATES',
          },
          { 
              title: 'BENEFICIARY',
              children: [
                  ['Name', '10772208 Canada Corp.'],
                  ['Phone', '1 (647) 612-7729'],
                  ['Address', '44 Clare Ave \nWelland ON Canada L3C0B7'] ]
          },
          { 
              title: 'BENEFICIARY BANK',
              children: [
                  ['Name', 'Royal Bank of Canada'],
                  ['Address', '2947 Bloor St. West, Toronto, Ontario, Canada M8X 1B8'],
                  ['Account Number', _vm.asset.account],
                  ['Bank SWIFT BIC Code:', _vm.asset.swiftCode],
                  ['Canadian Sort Code:', _vm.asset.sortCode],
                  ['Wire Reference', _vm.$store.getters.currAccount.userid, 'color:red; margin: 10px 0;'] ]
          }
      ]),function(group,index){return _c('div',{key:("fiat-info-row-" + index)},[_c('div',{staticClass:"fiat-info-title"},[_vm._v(_vm._s(group.title))]),_vm._v(" "),_vm._l((group.children),function(item,index){return _c('div',{key:("item-" + index),class:['fiat-info-row', 'js-copy-btn'],attrs:{"data-clipboard-text":item[1]},on:{"click":function($event){return _vm.$Message.success('Copy successful')}}},[_c('div',{staticClass:"fiat-info-label",style:(item[2])},[_vm._v(_vm._s(item[0]))]),_vm._v(" "),(item[1])?_c('div',{staticClass:"fiat-info-value",style:(item[2])},[_vm._v(_vm._s(item[1]))]):_vm._e()])})],2)}),_vm._v(" "),_c('Button',{staticClass:"fiat-confirm-btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("UNDERSTAND")])],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fiat-modal-footer"},[_c('div',{staticClass:"fiat-modal-footer-row"},[_vm._v("○ Min deposit amount：50.00 "+_vm._s(_vm.asset.name))]),_vm._v(" "),_c('div',{staticClass:"fiat-modal-footer-row"},[_vm._v("○ Deposit fee is 0.5%")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38895539","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/channel-specific/dynamics/fiatModal.vue
// module id = null
// module chunks = 